const API_BASE_URL = "https://9oe9srtrig.execute-api.ap-south-1.amazonaws.com";

export default API_BASE_URL;